import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import TopHeader from "./TopHeader";
import SideNav, { useSideNavItems } from "./SideNav";
import { bodyRowSx, mainContentSx, shellSx } from "./NewLayout.style";

const NewLayout = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const showSideNav = useSideNavItems().length > 0;

  const handleToggleNav = () => {
    setIsNavCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const onKeyDown = (event) => {
      const isToggleShortcut =
        (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "b";
      if (!isToggleShortcut) {
        return;
      }
      event.preventDefault();
      setIsNavCollapsed((prev) => !prev);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <Box sx={shellSx}>
      <CssBaseline />
      <TopHeader
        isNavCollapsed={isNavCollapsed}
        onToggleNav={handleToggleNav}
        showSideNav={showSideNav}
      />
      <Box sx={bodyRowSx}>
        {showSideNav ? <SideNav isCollapsed={isNavCollapsed} /> : null}
        <Box component="main" sx={mainContentSx}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default NewLayout;
